import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  container: {
    padding: '16px',
  },
  successSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: '24px',
    padding: '16px',
    backgroundColor: '#e8f5e8',
    borderRadius: '4px',
  },
  successIcon: {
    width: 24,
    height: 24,
    color: '#4caf50',
    marginRight: '8px',
  },
  successTitle: {
    color: '#4caf50',
    fontWeight: 'bold',
  },
  section: {
    marginBottom: '24px',
  },
  sectionTitle: {
    fontWeight: 'bold',
    marginBottom: '16px',
    fontSize: '1.1rem',
  },
  linkContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: '16px',
    padding: '16px',
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
    border: '1px solid #ddd',
  },
  linkText: {
    flex: 1,
    wordBreak: 'break-all',
    fontFamily: 'monospace',
    fontSize: '0.9rem',
  },
  copyButton: {
    flexShrink: 0,
  },
  detailsList: {
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
    border: '1px solid #ddd',
  },
  itemsContainer: {
    backgroundColor: '#f5f5f5',
    borderRadius: '4px',
    border: '1px solid #ddd',
    padding: '16px',
  },
  itemType: {
    marginBottom: '16px',
    '&:last-child': {
      marginBottom: 0,
    },
  },
  recipientsContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
  },
  recipientChip: {
    marginBottom: '8px',
  },
}));

export default useStyles;
